





































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { Route } from "vue-router";
import { Dictionary } from "vue-router/types/router";
import { Form as ElForm, Input } from "element-ui";
import { UserModule } from "@/store/modules/user";
// import { isValidUsername } from "@/utils/validate";
import LangSelect from "@/components/LangSelect/index.vue";
import Register from "./components/Register.vue";

@Component({
  name: "Login",
  components: {
    LangSelect,
    Register
  }
})
export default class extends Vue {
  private validateUsername = (rule: any, value: string, callback: Function) => {
    // if (!isValidUsername(value)) {
    //   callback(new Error("Please enter the correct user name"));
    // } else {
    //   callback();
    // }

    if (value.trim().length === 0) {
      callback(new Error("请输入用户名！"));
    } else {
      callback();
    }
  };

  private validatePassword = (rule: any, value: string, callback: Function) => {
    if (value.length < 6) {
      callback(new Error("密码不小于6位！"));
    } else {
      callback();
    }
  };

  private loginForm = {
    account: "",
    password: ""
  };

  private loginRules = {
    account: [{ validator: this.validateUsername, trigger: "blur" }],
    password: [{ validator: this.validatePassword, trigger: "blur" }]
    // password: [
    //   { required: true, message: "请输入密码", trigger: "blur" },
    //   {
    //     pattern: /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_]+$)(?![a-z0-9]+$)(?![a-z\W_]+$)(?![0-9\W_]+$)[a-zA-Z0-9\W_]{6,30}$/,
    //     message:
    //       "密码为数字，小写字母，大写字母，特殊符号 至少包含三种，长度为 6 - 30位"
    //   }
    // ]
  };

  private passwordType = "password";
  private loading = false;
  private showDialog = false;
  private capsTooltip = false;
  private redirect?: string;
  private otherQuery: Dictionary<string> = {};

  @Watch("$route", { immediate: true })
  private onRouteChange(route: Route) {
    // TODO: remove the "as Dictionary<string>" hack after v4 release for vue-router
    // See https://github.com/vuejs/vue-router/pull/2050 for details
    const query = route.query as Dictionary<string>;
    if (query) {
      this.redirect = query.redirect;
      this.otherQuery = this.getOtherQuery(query);
    }
  }

  mounted() {
    if (this.loginForm.account === "") {
      (this.$refs.account as Input).focus();
    } else if (this.loginForm.password === "") {
      (this.$refs.password as Input).focus();
    }
  }

  private checkCapslock(e: KeyboardEvent) {
    const { key } = e;
    this.capsTooltip =
      key !== null && key.length === 1 && key >= "A" && key <= "Z";
  }

  private showPwd() {
    if (this.passwordType === "password") {
      this.passwordType = "";
    } else {
      this.passwordType = "password";
    }
    this.$nextTick(() => {
      (this.$refs.password as Input).focus();
    });
  }

  private hideDialog() {
    this.showDialog = false;
  }

  private handleLogin() {
    (this.$refs.loginForm as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        this.loading = true;
        await UserModule.Login(this.loginForm)
          .then(() => {
            this.$router
              .push({
                path: this.redirect || "/",
                query: this.otherQuery
              })
              .catch(err => {
                console.warn(err);
              });
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
            return false;
          });

        // Just to simulate the time of the request
        // setTimeout(() => {
        //   this.loading = false;
        // }, 0.5 * 1000);
      } else {
        return false;
      }
    });
  }

  private getOtherQuery(query: Dictionary<string>) {
    return Object.keys(query).reduce((acc, cur) => {
      if (cur !== "redirect") {
        acc[cur] = query[cur];
      }
      return acc;
    }, {} as Dictionary<string>);
  }
}
